import React, { useState } from "react";
import MainLayout from "../components/MainLayout";
import AnnouncementForm from "../components/ChangeAnnouncementForm";
import { Typography } from "@mui/material";

const AnnouncementHome: React.FC = () => {
  const [finalDecision] = useState<string | null>(null); // Manage the state for final decision

  return (
    <MainLayout>
      <Typography variant="h4" sx={{ fontWeight: "bold", mb: 3, textAlign: "center" }}>
        Inform Stakeholders!
      </Typography>

      {/* Pass the updated decision state to AnnouncementForm */}
      <AnnouncementForm finalDecision={finalDecision} />
    </MainLayout>
  );
};

export default AnnouncementHome;